<template>
    <CodiceFeanorView tool-module="hashcatWorkbench" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
